import { z } from 'zod';

/**
 * Inspection details validation schema
 * Used when marking an order as inspected
 */
const inspectionSchema = z.object({
    /** Whether inspection has been completed */
    isComplete: z.boolean(),
    /** Date inspection was completed in ms since epoch */
    dateInspected: z.number().int().positive().optional(),
    /** Name/ID of agent who performed inspection */
    agent: z.string().optional(),
    /** Any notes from inspection */
    notes: z.string().optional(),
});
/**
 * Mark inspected body schema (for POST /:orderId/mark-inspected)
 */
const markInspectedBodySchema = z.object({
    inspection: inspectionSchema,
});
/**
 * Mark inspected form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markInspectedFormSchema)
 */
const markInspectedFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm that the vehicle inspection is complete',
    }),
});

export { inspectionSchema, markInspectedBodySchema, markInspectedFormSchema };
//# sourceMappingURL=inspectionValidation.js.map
